import Fetch from "utils/fetch";

export const getFamiliesByMaterialGroup = (value: number) =>
  Fetch.get(`/families:by-material-group?MaterialGroupId=${value}`).then(({ data }) => data);
